"use client"

import * as React from "react"
import { createContext } from "react"

export type GalleryOpenContextValue = {
  galleryOpenRef: React.MutableRefObject<boolean>
  isGalleryOpen: boolean
  setGalleryOpen: (open: boolean) => void
  galleryPortalRef: React.RefObject<HTMLDivElement | null> | null
} | null

export const GalleryOpenRefContext = createContext<GalleryOpenContextValue>(null)
